import React, { Suspense } from 'react';
import ErrorBoundary from '../../../../../../../../frame/components/error-boundary';
import AnimTips from '../../anim-tips';
import { observer } from 'mobx-react';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { InjectorService } from '@tencent/workbench';
import { AnimCornerMarkFeature } from '@src/framework/workbench/ui/anim-corner-mark/anim-corner-mark-feature';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

interface AnimTipsContainerProps {
    scale: number;
}

@observer
class AnimTipsContainer extends React.Component<AnimTipsContainerProps> {
    private animCornerMarkFeature?: AnimCornerMarkFeature;
    public constructor(props: AnimTipsContainerProps) {
        super(props);
        eventBus.once(EventKeys.WORKBENCH_IS_MOUNT, () => {
            this.animCornerMarkFeature = InjectorService.get(AnimCornerMarkFeature);
            this.forceUpdate();
        });
    }

    public render() {
        const slideModel = this.getSelectionService()?.currentSlide;
        const editingStateManager = this.getEditingStateManager();
        if (!this.animCornerMarkFeature) return null;

        return <>
            {
                (
                    this.getRightSideBarManager()?.isAnimationEditorShown
                    && !this.animCornerMarkFeature.shouldHideAllBadges && (
                        <ErrorBoundary>
                            <Suspense fallback={<div></div>}>
                                <AnimTips
                                    scale={this.props.scale}
                                    slide={slideModel}
                                    editingStateManager={editingStateManager}
                                />
                            </Suspense>
                        </ErrorBoundary>
                    )
                )
            }
        </>;
    }

    private getEditingStateManager() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).viewableServiceLayer
            ?.editingStateManager;
    }

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).viewableServiceLayer
            ?.selectionService;
    }

    private getRightSideBarManager() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).editableServiceLayer
            ?.rightSideBarManager;
    }
}

export default AnimTipsContainer;
